import { render } from "./UpdateFileNameModal.vue?vue&type=template&id=c71b2248&scoped=true"
import script from "./UpdateFileNameModal.vue?vue&type=script&lang=js"
export * from "./UpdateFileNameModal.vue?vue&type=script&lang=js"

import "./UpdateFileNameModal.vue?vue&type=style&index=0&id=c71b2248&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c71b2248"]])

export default __exports__